var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pr" },
    [
      _c(
        "span",
        {
          staticClass:
            "yxtbiz-joinlib_selectmask pa z-19 hand nowrap ellipsis bg-white",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectHandle.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.selectLabel) + "\n  ")]
      ),
      _c(
        "yxtf-select",
        {
          ref: "select",
          staticClass: "width-percent-100",
          attrs: { "popper-class": "yxtbiz-joinlib_selectpop" },
          on: {
            "visible-change": _vm.visibleChangeHandle,
            change: _vm.selectChange,
          },
          model: {
            value: _vm.selectId,
            callback: function ($$v) {
              _vm.selectId = $$v
            },
            expression: "selectId",
          },
        },
        [
          _c(
            "template",
            { slot: "fixed-header" },
            [
              _c(
                "Search",
                {
                  ref: "search",
                  attrs: { readonly: _vm.loading },
                  on: { search: _vm.search },
                },
                [
                  _vm.hasCreatePermission
                    ? _c("i", {
                        staticClass:
                          "yxtbiz-joinlib_addfolder ph8 lh32 text-bf hand yxt-icon-plus",
                        class: {
                          "yxtbiz-joinlib_notallowed":
                            _vm.breadcrumbs.length === 0,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.addFolder.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm.breadcrumbs.length > 1
                ? _c("Breadcrumbs", {
                    ref: "breadcrumbs",
                    attrs: { list: _vm.breadcrumbs },
                    on: { change: _vm.breadcrumbHandle },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("DataEmpty", {
            attrs: {
              slot: "empty",
              loading: _vm.loading,
              "empty-text": _vm.emptyText,
            },
            slot: "empty",
          }),
          _vm._l(_vm.list, function (item) {
            return _c(
              "yxtf-option",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !item.hide,
                    expression: "!item.hide",
                  },
                ],
                key: item.id,
                staticClass: "yxtbiz-joinlib_flex yxtbiz-joinlib_flexcenter",
                attrs: { value: item.id, label: item.label },
              },
              [
                _c("yxtf-svg", {
                  attrs: {
                    width: "20px",
                    height: "20px",
                    "remote-url": _vm.svgUrl,
                    "icon-class": "folder-default",
                  },
                }),
                _c("div", { staticClass: "yxtbiz-joinlib_flex1 pr" }, [
                  _c("i", [_vm._v("  ")]),
                  _c("label", { staticClass: "pa nowrap ellipsis" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                ]),
                item.children
                  ? _c("i", {
                      staticClass:
                        "yxtbiz-joinlib_right-icon ml24 yxt-icon-arrow-right text-center color-gray-6",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.loadChildList(item)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }